<div class="comp-page">

    <!-- Fejléc -->
    <div class="comp-head">
        <div class="comp-head__copy">
            <h1 class="stk-page-title">Komponensek</h1>
            <div class="stk-page-sub">Minden nyomtatott és vásárolt alkatrész — ezekből állnak össze a termékek.</div>
        </div>
        <button type="button" class="comp-archive-btn" (click)="openArchive()">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="4" rx="1"></rect><path d="M5 8v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8"></path><line x1="10" y1="12" x2="14" y2="12"></line></svg>
            Archívum
        </button>
        <button type="button" class="comp-add-btn" (click)="openComponentEditor()">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><line x1="12" y1="4" x2="12" y2="20"></line><line x1="4" y1="12" x2="20" y2="12"></line></svg>
            Új komponens
        </button>
    </div>

    <!-- Nyomtatási várólista összegző -->
    <div class="comp-queue" *ngIf="queue">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#A14D4D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="comp-queue__icon"><path d="M12 3 L22 20 H2 Z"></path><line x1="12" y1="9.5" x2="12" y2="14"></line><circle cx="12" cy="17" r="0.4" fill="#A14D4D"></circle></svg>
        <div class="comp-queue__copy">
            <div class="comp-queue__title">Nyomtatási várólista</div>
            <div class="comp-queue__sub">{{ queueSummary }}</div>
        </div>
        <button type="button" class="comp-low-btn" [class.comp-low-btn--active]="lowOnly" (click)="toggleLowOnly()">
            {{ lowOnly ? 'Összes mutatása' : 'Csak hiányosak' }}
        </button>
    </div>

    <!-- Kompakt szűrősor -->
    <div class="comp-filters">
        <div class="comp-search">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#9AA098" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="6.5"></circle><line x1="16" y1="16" x2="21" y2="21"></line></svg>
            <input type="text" [value]="search" (input)="onSearchChange($any($event.target).value)" placeholder="Keresés név vagy SKU…">
        </div>

        <div class="comp-chips">
            <button type="button" class="comp-chip" *ngFor="let chip of gameChips"
                    [class.comp-chip--active]="selectedGame === chip.label"
                    (click)="pickGame(chip.label)">
                <span class="comp-chip__dot" *ngIf="chip.dot" [style.background]="chip.dot"></span>
                {{ chip.label }}
            </button>
        </div>

        <div class="comp-select" *ngIf="catOptions.length">
            <select [value]="selectedCat" (change)="onCatChange($any($event.target).value)">
                <option *ngFor="let o of catOptions" [value]="o.value">{{ o.label }}</option>
            </select>
            <span class="comp-select__chev">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="6,9 12,15 18,9"></polyline></svg>
            </span>
        </div>

        <div class="comp-select">
            <select [value]="selectedType" (change)="onTypeChange($any($event.target).value)">
                <option *ngFor="let o of typeOptions" [value]="o.value">{{ o.label }}</option>
            </select>
            <span class="comp-select__chev">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="6,9 12,15 18,9"></polyline></svg>
            </span>
        </div>
    </div>

    <!-- Táblázat -->
    <div class="comp-table">
        <div class="comp-row comp-row--head">
            <div class="stk-table-head">Komponens</div>
            <div class="stk-table-head">Típus</div>
            <div class="stk-table-head">Súly</div>
            <div class="stk-table-head">Nyomt. idő</div>
            <div class="stk-table-head">Önköltség</div>
            <div class="stk-table-head">Készlet</div>
            <div></div>
        </div>

        <ng-container *ngFor="let row of pagedRows; trackBy: trackRow">
            <div class="comp-row" [class.comp-row--warn]="row.level === 'warn'" [class.comp-row--crit]="row.level === 'crit'">
                <div class="comp-cell-name">
                    <app-component-image [imageFileName]="row.imageFile"></app-component-image>
                    <div class="comp-cell-name__copy">
                        <div class="comp-cell-name__title">
                            <span class="comp-name-text">{{ row.name }}</span>
                            <span class="comp-custom-badge" *ngIf="row.custom" title="Egyedi, rendelésre gyártott komponens — nem tartunk belőle állandó készletet">
                                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 3 l4 4 L8 20 H4 v-4 Z"></path></svg>
                                Egyedi
                            </span>
                        </div>
                        <div class="comp-cell-name__sku">{{ row.sku }}</div>
                    </div>
                </div>

                <div class="comp-cell-type">
                    <span class="comp-type-pill" [ngClass]="'comp-type-pill--' + row.typeKey">{{ row.typeLabel }}</span>
                </div>

                <div class="comp-cell-plain" data-label="Súly">{{ row.weightLabel }}</div>

                <div class="comp-cell-time" data-label="Nyomt. idő">
                    <button type="button" class="comp-open-btn" *ngIf="row.isAssembled"
                            [class.comp-open-btn--open]="isOpen(row)"
                            title="Összetevők mutatása készlettel"
                            (click)="toggleOpen(row)">
                        {{ row.timeLabel }}
                        <span class="comp-open-btn__chev">
                            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="6,9 12,15 18,9"></polyline></svg>
                        </span>
                    </button>
                    <span class="comp-cell-plain" *ngIf="!row.isAssembled">{{ row.timeLabel }}</span>
                </div>

                <div class="comp-cell-cost" data-label="Önköltség">
                    {{ row.costLabel }}<span class="comp-cell-cost__est" *ngIf="row.costEstimated"
                          title="Becsült önköltség: a komponens anyagához nincs ár rögzítve az Anyagok képernyőn, ezért 3200 Ft/kg alapárral számolunk.">✳</span>
                </div>

                <div class="comp-cell-stock">
                    <!-- Egyedi (rendelésre gyártott) komponensnél nincs értelme a
                         készletszint — rendelésenként gyártjuk. -->
                    <ng-container *ngIf="!row.custom; else madeToOrder">
                        <div class="comp-cell-stock__top">
                            <span class="comp-stock-pill" [ngClass]="'comp-stock-pill--' + row.level" [title]="row.stateLabel">{{ row.stock }} db</span>
                            <button type="button" class="comp-modify-btn"
                                    [disabled]="!row.canManageStock"
                                    [title]="row.canManageStock ? 'Készlet módosítása' : 'Az összeépített komponens készlete az összetevőkből számolódik — közvetlenül nem módosítható.'"
                                    (click)="openStockModal(row)">Módosít</button>
                        </div>
                        <span class="comp-min-label" [ngClass]="'comp-min-label--' + row.level">{{ row.minLabel }}</span>
                        <span class="comp-reserved" *ngIf="row.hasReserved" [class.comp-reserved--danger]="row.reservedDanger"
                              title="Aktív, még feladatlan rendelések ennyit foglalnak le ebből a komponensből">
                            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="11" width="14" height="10" rx="2"></rect><path d="M8 11 V7 a4 4 0 0 1 8 0 v4"></path></svg>
                            {{ row.reservedLabel }}
                        </span>
                    </ng-container>
                    <ng-template #madeToOrder>
                        <span class="comp-made-to-order" title="Egyedi, rendelésre gyártott komponens — nem tartunk belőle készletet">Rendelésre gyártott</span>
                    </ng-template>
                </div>

                <div class="comp-actions">
                    <button type="button" class="comp-action-btn comp-action-btn--edit" title="Komponens szerkesztése" (click)="openEdit(row)">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 3 l4 4 L8 20 H4 v-4 Z"></path></svg>
                    </button>
                    <button type="button" class="comp-action-btn comp-action-btn--copy" title="Komponens duplikálása" [disabled]="row.busy" (click)="duplicateRow(row)">
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="12" height="12" rx="2"></rect><path d="M6 15 H5 a2 2 0 0 1 -2 -2 V5 a2 2 0 0 1 2 -2 h8 a2 2 0 0 1 2 2 v1"></path></svg>
                    </button>
                    <button type="button" class="comp-action-btn comp-action-btn--delete" title="Komponens törlése" (click)="removeRow(row)">
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="7" x2="20" y2="7"></line><path d="M9 7 V5 a1 1 0 0 1 1 -1 h4 a1 1 0 0 1 1 1 v2"></path><path d="M6 7 l1 13 a1 1 0 0 0 1 1 h8 a1 1 0 0 0 1 -1 l1 -13"></path></svg>
                    </button>
                </div>
            </div>

            <!-- Összetevők lenyitva -->
            <div class="comp-bom" *ngIf="isOpen(row)">
                <div class="comp-bom__kicker">Így épül össze — 1 egységhez</div>
                <div class="comp-bom__loading" *ngIf="bomLoading.has(row.id)">Összetevők betöltése…</div>
                <div class="comp-bom__row" *ngFor="let child of childrenOf(row)">
                    <app-component-image class="comp-bom__img" [imageFileName]="child.imageFile"></app-component-image>
                    <div class="comp-bom__copy">
                        <div class="comp-bom__name">{{ child.name }}</div>
                        <div class="comp-bom__meta">{{ child.sku }} · {{ child.qty }} db / egység</div>
                    </div>
                    <span class="comp-bom__pill" [class.comp-bom__pill--low]="!child.ok">{{ child.stockLabel }}</span>
                    <span class="comp-bom__enough" [class.comp-bom__enough--missing]="child.missing">{{ child.enoughLabel }}</span>
                </div>
                <div class="comp-bom__loading" *ngIf="!bomLoading.has(row.id) && !childrenOf(row).length">Ennek a komponensnek nincs rögzített összetevője.</div>
            </div>
        </ng-container>

        <div class="comp-empty" *ngIf="fetching">Betöltés…</div>
        <div class="comp-empty" *ngIf="!fetching && !pagedRows.length">
            {{ loadFailed ? 'A komponens lista most nem érhető el — próbáld újra később.' : 'Nincs a szűrésnek megfelelő komponens.' }}
        </div>
    </div>

    <!-- Lábléc + lapozó -->
    <div class="comp-footer">
        <div class="comp-footer__label">{{ footerLabel }}</div>
        <div class="comp-pager" *ngIf="filteredRows.length > pageSizeOptions[0]">
            <div class="comp-select comp-select--pager">
                <select [value]="pageSize" (change)="onPageSizeChange($any($event.target).value)">
                    <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }} / oldal</option>
                </select>
                <span class="comp-select__chev">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="6,9 12,15 18,9"></polyline></svg>
                </span>
            </div>
            <button type="button" class="comp-pager-btn" [disabled]="pageIndex === 0" (click)="prevPage()">Előző</button>
            <span class="comp-pager__label">{{ pageRangeLabel }}</span>
            <button type="button" class="comp-pager-btn" [disabled]="pageIndex >= totalPages - 1" (click)="nextPage()">Következő</button>
        </div>
    </div>

    <!-- Archívum modal (kivezetett komponensek) -->
    <div class="stk-modal-overlay comp-stock-overlay" *ngIf="archiveOpen" (click)="closeArchive()">
        <div class="comp-archive-modal" (click)="$event.stopPropagation()">
            <div class="comp-stock-modal__title">Archivált komponensek</div>
            <div class="comp-stock-modal__sub">
                Ezek a tételek kikerültek a listákból, de az előzményük (készletmozgás, rendelés) megmaradt. Bármelyik visszaállítható.
            </div>

            <div class="comp-archive-empty" *ngIf="!archiveLoading && !archivedRows.length">Nincs archivált komponens.</div>
            <div class="comp-archive-empty" *ngIf="archiveLoading">Betöltés…</div>

            <div class="comp-archive-list" *ngIf="!archiveLoading && archivedRows.length">
                <div class="comp-archive-row" *ngFor="let row of archivedRows">
                    <app-component-image [imageFileName]="row.imageFile"></app-component-image>
                    <div class="comp-archive-row__copy">
                        <div class="comp-archive-row__title">{{ row.name }}</div>
                        <div class="comp-archive-row__meta">{{ row.sku }} · {{ row.typeLabel }} · {{ row.archivedLabel }}</div>
                    </div>
                    <button type="button" class="stk-btn stk-btn--ghost comp-archive-row__btn"
                            [disabled]="restoringId === row.id" (click)="restoreArchived(row)">
                        {{ restoringId === row.id ? 'Visszaállítás…' : 'Visszaállítás' }}
                    </button>
                </div>
            </div>

            <div class="comp-stock-modal__actions">
                <button type="button" class="stk-btn stk-btn--ghost" (click)="closeArchive()">Bezárás</button>
            </div>
        </div>
    </div>

    <!-- Készlet módosítás modal -->
    <div class="stk-modal-overlay comp-stock-overlay" *ngIf="stockModal" (click)="closeStockModal()">
        <div class="comp-stock-modal" (click)="$event.stopPropagation()">
            <div class="comp-stock-modal__title">Készlet módosítása</div>
            <div class="comp-stock-modal__sub">{{ stockModal.row.name }} · jelenlegi készlet: {{ stockModal.row.stock }} db</div>
            <div class="comp-stock-modal__modes">
                <button type="button" class="comp-mode-chip" [class.comp-mode-chip--active]="stockModal.mode === 'add'" (click)="setStockMode('add')">Hozzáadás</button>
                <button type="button" class="comp-mode-chip" [class.comp-mode-chip--active]="stockModal.mode === 'remove'" (click)="setStockMode('remove')">Kivétel</button>
            </div>
            <div class="comp-stock-modal__qty">
                <input type="text" inputmode="numeric" [value]="stockModal.qty" (input)="onStockQtyInput($event)" placeholder="Darabszám">
                <span>db</span>
            </div>
            <div class="comp-stock-modal__preview">{{ stockModalPreview }}</div>
            <div class="comp-stock-modal__actions">
                <button type="button" class="stk-btn stk-btn--ghost" (click)="closeStockModal()">Mégse</button>
                <button type="button" class="stk-btn stk-btn--accent" [disabled]="!stockModalValid || savingStock" (click)="confirmStockModal()">
                    {{ savingStock ? 'Mentés…' : 'Mentés' }}
                </button>
            </div>
        </div>
    </div>

</div>
